/* eslint-disable no-unreachable */

function javascript_old(hljs) {

  return hljs.requireLanguage("typescript").rawDefinition();
}

module.exports = javascript_old;
